/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable import/no-cycle */
/* eslint-disable object-curly-newline */
import React from "react";

import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

import SompoLoading from "../../../../component/loading/SompoLoading";
import { HomeProps } from "../../Home";
import OnGoing from "./OnGoing";
import CurriculumOnGoing from "./CurriculumOnGoing";
import SompoContext from "../../../../logic/context/SompoContext";

// Constants.
interface TabConstant {
    tabIndex: number;
    name: string;
}
const TabConstants: { [key: string]: TabConstant } = {
    CAREER_ONGOING: {
        tabIndex: 0,
        name: "講座",
    },
    CURRICULUM_ONGOING: {
        tabIndex: 1,
        name: "カリキュラム",
    },
};

// Props.
interface CustomTabProps {
    tabIndex: number;
    name: string;
    count: number;
    children?: React.ReactNode;
    selected: boolean;
}
const createCustomTabProps = (constant: TabConstant, count: number, content: React.ReactNode, selectedTab: number, showCurriculums?: boolean) =>
    showCurriculums === undefined || showCurriculums
        ? ({
              tabIndex: constant.tabIndex,
              name: constant.name,
              count,
              selected: constant.tabIndex === selectedTab,
              children: content,
          } as CustomTabProps)
        : null;

// Sub components.
// タブ
const TabLabel = (props: Partial<CustomTabProps>) => {
    const { name, count, selected } = props;
    return (
        <Typography variant="h6" fontWeight={selected ? "bold" : "normal"} sx={{ color: selected ? "secondary" : "#999999" }}>
            {`${name} (${count || 0})`}
        </Typography>
    );
};
const toTab = (props: Partial<CustomTabProps> | null) =>
    props && (
        <Tab
            key={`CourseTop-Tab-${props.tabIndex}`}
            label={<TabLabel {...props} />}
            sx={{
                width: "auto",
                borderRadius: "6px 6px 0 0",
                transition: "0.3s",
                "&:hover": {
                    opacity: "0.7",
                },
                p: 1,
            }}
        />
    );
const renderTabs = (tabs: Array<CustomTabProps | null>) => tabs.map((tabProps) => toTab(tabProps));

// タブ内容
const CustomTabPanel = (props: Partial<CustomTabProps>) => {
    const { selected, children } = props;
    return (
        <Box
            key={`CourseTop-TabPanel-${props.tabIndex}`}
            hidden={!selected}
            sx={{
                height: { xs: "auto", sm: "auto", md: "auto" },
                maxWidth: "100%",
            }}
        >
            {selected && <Box sx={{ width: "100%" }}>{children}</Box>}
        </Box>
    );
};
const toPanel = (props: Partial<CustomTabProps> | null) => props && <CustomTabPanel key={`CourseTop-CustomTabPanel-${props.tabIndex}`} {...props} />;
const renderPanels = (tabs: Array<CustomTabProps | null>) => tabs.map((tabProps) => toPanel(tabProps));

// Main component.
const CourseTop = (props: HomeProps) => {
    // Values from props.
    const { categories, histories } = props;
    const { showCurriculums: showCurriculumsFn } = categories;
    const showCurriculums = showCurriculumsFn();
    // console.log("showCurriculums", showCurriculums);

    // States.
    const [selectedTab, setSelectedTab] = React.useState<number>(TabConstants.CAREER_ONGOING.tabIndex);

    // Event handlers.
    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        // console.log("handleChangeTab", newValue);
        setSelectedTab(newValue);
    };

    // Context.
    const sompoContext = React.useContext(SompoContext);

    // タブ、タブ内容をまとめて作成
    const tabs = [
        createCustomTabProps(
            TabConstants.CAREER_ONGOING,
            histories.careers.onGoing.length,
            <OnGoing histories={histories} categories={categories} />,
            selectedTab
        ),
        createCustomTabProps(
            TabConstants.CURRICULUM_ONGOING,
            histories.curriculums.onGoing.length,
            <CurriculumOnGoing histories={histories} categories={categories} />,
            selectedTab,
            showCurriculums
        ),
    ];
    // console.log("tabs", tabs);

    // Render Component.
    // fetchが終わるまでローディングアイコンを表示
    return sompoContext.loading ? (
        <Box sx={{ position: "relative", minHeight: "100px" }}>
            <SompoLoading />
        </Box>
    ) : (
        <>
            <Box sx={{ width: "100%" }}>
                <Tabs
                    value={selectedTab}
                    onChange={handleChangeTab}
                    sx={{
                        minHeight: "50px",
                        height: "50px",
                        borderBottom: "2px solid #E9EEF5",
                    }}
                    textColor="secondary"
                    indicatorColor="secondary"
                    {...(showCurriculums && {
                        variant: "scrollable",
                        scrollButtons: true,
                        allowScrollButtonsMobile: true,
                    })}
                >
                    {/* タブのレンダリング */}
                    {renderTabs(tabs)}
                </Tabs>
            </Box>

            {/* タブ内容のレンダリング */}
            {renderPanels(tabs)}
        </>
    );
};
export default CourseTop;
